import { useState, useEffect } from "react";
import Header from "../components/Header";

const API_URL = "https://prakruthi.vercel.app";

function UserInfo() {
  const [staff, setStaff] = useState([]);
  const [admin, setAdmin] = useState({
    name: "",
    email: "",
    password: "",
    role: "",
    phone: "",
    image: "",
  });
  const [newStaff, setNewStaff] = useState({
    name: "",
    email: "",
    role: "",
    password: "",
    phone: "",
    image: "",
  });
  const [staffId, setStaffId] = useState("");
  const [staffDetails, setStaffDetails] = useState(null);

  useEffect(() => {
    fetchStaff();
  }, []);

  const fetchStaff = async () => {
    try {
      const res = await fetch(`${API_URL}/api/admin/all`);
      const data = await res.json();
      setStaff(data.data);
    } catch (error) {
      console.error("Error fetching staff:", error);
    }
  };

  const registerAdmin = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_URL}/api/admin/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(admin),
      });

      if (res.ok) {
        alert("Admin registered successfully");
      } else {
        console.error("Error registering admin:", await res.text());
      }
    } catch (error) {
      console.error("Error registering admin:", error);
    }
  };

  const addStaff = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_URL}/api/admin/add`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(newStaff),
      });

      const data = await res.json();
      if (res.ok) {
        alert("Staff added successfully");
        fetchStaff();
      } else {
        console.error("Error adding staff:", data);
      }
    } catch (error) {
      console.error("Error adding staff:", error);
    }
  };

  const getStaffById = async () => {
    try {
      const res = await fetch(`${API_URL}/api/admin/get/${staffId}`);
      if (res.ok) {
        const data = await res.json();
        setStaffDetails(data);
      } else {
        console.error("Error fetching staff details:", await res.text());
      }
    } catch (error) {
      console.error("Error fetching staff details:", error);
    }
  };

  return (
    <>
      <Header />
      <div className="p-6 max-w-5xl mx-auto bg-gray-100 min-h-screen">
        <h1 className="text-3xl font-bold text-center text-blue-700 mb-6">
          Admin Dashboard
        </h1>

        <div className="grid md:grid-cols-2 gap-6">
          {/* Register Admin */}
          {/* Register Admin */}
          <div className="bg-white shadow-md p-6 rounded-lg">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              Register Admin
            </h2>

            <input
              type="text"
              placeholder="Name"
              onChange={(e) => setAdmin({ ...admin, name: e.target.value })}
              className="border p-2 w-full rounded mb-2"
            />

            <input
              type="email"
              placeholder="Email"
              onChange={(e) => setAdmin({ ...admin, email: e.target.value })}
              className="border p-2 w-full rounded mb-2"
            />

            <input
              type="text"
              placeholder="Phone"
              onChange={(e) => setAdmin({ ...admin, phone: e.target.value })}
              className="border p-2 w-full rounded mb-2"
            />

            {/* Role Selection */}
            <select
              onChange={(e) => setAdmin({ ...admin, role: e.target.value })}
              className="border p-2 w-full rounded mb-2"
            >
              <option value="">Select Role</option>
              <option value="Super Admin">Super Admin</option>
              <option value="Admin">Admin</option>
              <option value="Manager">Manager</option>
            </select>

            <input
              type="password"
              placeholder="Password"
              onChange={(e) => setAdmin({ ...admin, password: e.target.value })}
              className="border p-2 w-full rounded mb-2"
            />

            <input
              type="url"
              placeholder="Profile Image URL"
              onChange={(e) => setAdmin({ ...admin, image: e.target.value })}
              className="border p-2 w-full rounded mb-2"
            />

            <button
              onClick={registerAdmin}
              className="w-full bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
            >
              Register
            </button>
          </div>

          {/* Add Staff */}
          <div className="bg-white shadow-md p-6 rounded-lg">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              Add Staff
            </h2>
            <input
              type="text"
              placeholder="Name"
              onChange={(e) =>
                setNewStaff({ ...newStaff, name: e.target.value })
              }
              className="border p-2 w-full rounded mb-2"
            />
            <input
              type="email"
              placeholder="Email"
              onChange={(e) =>
                setNewStaff({ ...newStaff, email: e.target.value })
              }
              className="border p-2 w-full rounded mb-2"
            />
            <input
              type="text"
              placeholder="Phone"
              onChange={(e) => setAdmin({ ...newStaff, phone: e.target.value })}
              className="border p-2 w-full rounded mb-2"
            />

            {/* Role Selection */}
            <select
              onChange={(e) => setAdmin({ ...newStaff, role: e.target.value })}
              className="border p-2 w-full rounded mb-2"
            >
              <option value="">Select Role</option>
              <option value="Admin">Admin</option>
            </select>

            <input
              type="password"
              placeholder="Password"
              onChange={(e) =>
                setAdmin({ ...newStaff, password: e.target.value })
              }
              className="border p-2 w-full rounded mb-2"
            />

            <input
              type="url"
              placeholder="Profile Image URL"
              onChange={(e) => setAdmin({ ...newStaff, image: e.target.value })}
              className="border p-2 w-full rounded mb-2"
            />
            <button
              onClick={addStaff}
              className="w-full bg-green-500 text-white p-2 rounded hover:bg-green-600"
            >
              Add Staff
            </button>
          </div>
        </div>

        <div className="mt-6 bg-white shadow-md p-6 rounded-lg">
          <div className="mb-6">
            <h2 className="text-xl font-semibold">Get Staff by ID</h2>
            <input
              type="text"
              placeholder="Staff ID"
              onChange={(e) => setStaffId(e.target.value)}
              className="border p-2 m-2"
            />
            <button
              onClick={getStaffById}
              className="bg-purple-500 text-white p-2"
            >
              Fetch Staff
            </button>
          </div>
        </div>
        {/* Staff List */}
        <div className="mt-6 bg-white shadow-md p-6 rounded-lg">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Staff List
          </h2>
          <ul>
            {staff.map((s) => (
              <li key={s._id} className="border-b p-2 text-gray-700">
                {s.name} - {s.role}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}

export default UserInfo;
